export const SIGNALR_HUB_NAME = 'uniteaq';

export const SIGNALR_EVENTS = {
	SensorDataReceived: 'SensorDataReceived',
} as const;

export const WORKER_DEBOUNCE_INTERVAL_MS = 2000;

export const MAIN_THREAD_DEBOUNCE_INTERVAL_MS = 1000;

export const TOKEN_REFRESH_CHECK_INTERVAL_MS = 12000;

export const TOKEN_EXPIRY_BUFFER_SECONDS = 15;

export const SLICE_NAME = 'signalRLive';

export const DATA_KEY_SEPARATOR = '_';

